/* eslint-disable react/no-children-prop,react/prop-types */
import React from 'react';
import { Route, Link } from 'react-router-dom';

const ListItemLink = ({ to, ...props }) => {
  let path = '';
  if (typeof to === 'string') {
    path = to;
  } else if (typeof to === 'object') {
    path = to.pathname;
  }
  return (
    <Route
      path={path}
      children={({ match }) => {
        const isActive =
          (props.exact && match && match.isExact) || (!props.exact && match);
        return (
          <li className={isActive ? 'active' : ''}>
            <Link to={to} {...props} />
          </li>
        );
      }}
    />
  );
};

export default ListItemLink;



// WEBPACK FOOTER //
// ./src/components/Common/ListItemLink/ListItemLink.js